/**
 * Layout constants for the bottom-right map controls cluster.
 *
 * The cluster is the single owner of the bottom-right corner of the map viewport.
 * Every control inside it is laid out with flexbox, so these are the only
 * hand-computed offsets in the corner — individual controls must not position
 * themselves.
 */

/** Height of the fixed bottom toolbar (`@components/toolbar/Toolbar`), in px. */
const TOOLBAR_HEIGHT = 41;

/** Height of the single-image carousel that sits above the toolbar, in px. */
const CAROUSEL_HEIGHT = 196;

/** Breathing room between the cluster and whatever sits below it, in px. */
const EDGE_GAP = 8;

export const MAP_CONTROLS_LAYOUT = {
	/** Distance from the right edge of the viewport. */
	right: EDGE_GAP,

	/** Default distance from the bottom of the viewport (clears the toolbar). */
	bottom: TOOLBAR_HEIGHT + EDGE_GAP,

	/**
	 * Distance from the bottom while the single-image carousel is open.
	 * The carousel spans the full viewport width, so the cluster lifts above it
	 * rather than shifting sideways.
	 */
	bottomWithCarousel: TOOLBAR_HEIGHT + CAROUSEL_HEIGHT + EDGE_GAP,

	/** Vertical spacing between stacked controls in the rail. */
	railGap: EDGE_GAP,

	/** Horizontal spacing between the lateral readout (scale bar) and the rail. */
	asideGap: 12,

	/** Edge length of a square control button. */
	buttonSize: 40,

	/** Glyph size inside a control button. */
	iconSize: 18,

	/**
	 * Above the map and its layers, below sidebars and modals.
	 * One z-index for the whole corner instead of one per control.
	 */
	zIndex: 19,
};
